<template>
	<header class="site-header" v-bind:class="[($route.meta.headerTheme ? 'site-header--' + $route.meta.headerTheme : null), {
		'site-header--fill': $route.meta.isHeaderFilled,
		'site-header--burger-nav-open': burgerOpen
	}]">
		<div class="site-header__centraliser">

			<div class="grid grid--g32--desk-lap grid--middle grid--auto grid--spread-between">
				<div class="grid__item">

					<div class="grid grid--auto grid--middle">
						<div class="grid__item">

							<router-link :to="{ name: 'Homepage' }">
								<img class="site-header__logo" src="@/assets/img/logo-white-sm.png" alt="IGT logo" />
							</router-link>

						</div>
						<div class="grid__item">

							<div class="site-header__burger-content nav grid grid--auto--desk grid--b0--port grid--middle--desk grid--vertical--port grid--v-spread-between--port">

								<mq-layout :mq="['mob', 'ptab', 'ltab']" class="grid__item">

									<div class="grid grid--middle grid--right grid--auto grid--g16--desk grid--g8--port">
										<div v-if="$root.userRegions && !$route.meta.isAdmin" class="grid__item">

											<div class="site-header__regions">
												<GlobalRegionIndicator class="site-header__region-indicator" :region="regionLabel($root.userSelectedRegionKey)" @click.native.stop="showRegionSelector = !showRegionSelector; closeTooltip(); trackEvent([
													'global-region-selector-clicked',
													showRegionSelector ? 'opened' : 'closed',
													$root.$data.user ? $root.$data.user.trackName : null,
													0,
													false
												])"></GlobalRegionIndicator>
												<RegionSelector v-show="showRegionSelector" class="site-header__region-selector" v-model="$root.userSelectedRegionKey" :hasUserRegions="true" @input="showRegionSelector = false; trackEvent([
													'global-region-changed',
													$root.userSelectedRegionKey,
													$root.$data.user ? $root.$data.user.trackName : null,
													0,
													false
												])" @click.native.stop></RegionSelector>
											</div>

										</div>
										<div class="grid__item">

											<span class="site-header__icon site-header__icon--burger-close fonticon fonticon--close--filled" @click="burgerOpen = false"></span>

										</div>
									</div>

								</mq-layout>
								<div class="grid__item">

									<ul class="site-header__nav grid grid--middle--desk grid--g32--not-lap grid--g24--desk-lap grid--auto--desk">
										<li class="grid__item dropdown">
										<div class="has-submenu">
											<router-link :to="{ name: 'AboutUs' }" class="site-header__nav-action dropbtn" @click.native="burgerOpen = false">
												<span>About Us</span>
											</router-link>
												<div class="caret_icon" @click="showHide()"></div>
										</div>
											<div class="dropdown-content">
												<router-link :to="{ name: 'Casino' }" class="site-header__nav-action dropbtn" @click.native="burgerOpen = false">
													<span>Casino</span>
												</router-link>
												<router-link :to="{ name: 'Sports' }" class="site-header__nav-action dropbtn" @click.native="burgerOpen = false">
													<span>Sports</span>
												</router-link>
											</div>
										</li>
										<li class="grid__item dropdown" v-if="!$root.$data.user || $root.userHasPermission({
											'igt': ['AM', 'CM', 'SA'],
											'operator': ['affiliate', 'customer', 'performance'],
										})">
											<router-link v-if="$root.$data.user" :to="{ name: 'Games' }" class="site-header__nav-action dropbtn" @click.native="burgerOpen = false">
												<span>Games</span>
											</router-link>
											<router-link v-else :to="{ name: 'Login' }" class="site-header__nav-action site-header__nav-action--login" @click.native="burgerOpen = false">
												<span class="site-header__nav-icon fonticon fonticon--lock"></span>
												<span>Games</span>
											</router-link>
										</li>
										<!--<li class="grid__item" v-if="!$root.$data.user || $root.userHasPermission({
											'igt': ['AM', 'CM', 'SA'],
											'operator': ['affiliate', 'customer', 'performance'],
										})">
											<router-link v-if="$root.$data.user" :to="{ name: 'PromotionalTools' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>Engagement Platform</span>
											</router-link>
											<router-link v-else :to="{ name: 'Login' }" class="site-header__nav-action site-header__nav-action--login" @click.native="burgerOpen = false">
												<span class="site-header__nav-icon fonticon fonticon--lock"></span>
												<span>Engagement Platform</span>
											</router-link>
										</li>-->
										<li class="grid__item">
											<router-link :to="{ name: 'PromotionalTools' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>Engagement Platform</span>
											</router-link>
										</li>
										<li class="grid__item" v-if="!$root.$data.user || $root.userHasPermission({
											'igt': ['AM', 'CM', 'SA'],
											'operator': ['affiliate', 'customer', 'performance'],
										})">
											<router-link v-if="$root.$data.user" :to="{ name: 'AssetManager' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>Assets</span>
											</router-link>
											<router-link v-else :to="{ name: 'Login' }" class="site-header__nav-action site-header__nav-action--login" @click.native="burgerOpen = false">
												<span class="site-header__nav-icon fonticon fonticon--lock"></span>
												<span>Assets</span>
											</router-link>
										</li>
										<li class="grid__item">
											<router-link :to="{ name: 'Roadmap' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>Roadmap</span>
											</router-link>
										</li>
										<li class="grid__item" v-if="!$root.$data.user || $root.userHasPermission({
											'igt': ['AM', 'CM', 'SA'],
											'operator': ['customer', 'performance'],
										})">
											<router-link v-if="$root.$data.user" :to="{ name: 'Documents' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>Documents</span>
											</router-link>
											<router-link v-else :to="{ name: 'Login' }" class="site-header__nav-action site-header__nav-action--login" @click.native="burgerOpen = false">
												<span class="site-header__nav-icon fonticon fonticon--lock"></span>
												<span>Documents</span>
											</router-link>
										</li>
										<li class="grid__item">
											<router-link :to="{ name: 'NewsArchive' }" class="site-header__nav-action" @click.native="burgerOpen = false">
												<span>News</span>
											</router-link>
										</li>
										<li class="grid__item" v-if="!$root.$data.user || $root.userHasPermission({
											'igt': ['AM', 'CM', 'SA'],
											'operator': ['affiliate', 'customer', 'performance'],
										})">
											<div v-if="$root.$data.user" id="beamer-widget" class="site-header__nav-action">Updates</div>
											<router-link v-else :to="{ name: 'Login' }" class="site-header__nav-action site-header__nav-action--login" @click.native="burgerOpen = false">
												<span class="site-header__nav-icon fonticon fonticon--lock"></span>
												<span>Updates</span>
											</router-link>
										</li>
									</ul>

								</div>
								<mq-layout :mq="['mob', 'ptab', 'ltab']" class="grid__item">

									<router-link class="site-header__btn site-header__btn--login btn btn--style--stroke" :to="{ name:'Login' }" v-if="!$root.$data.user" @click.native="burgerOpen = false">
										<span>Login</span>
									</router-link>

									<span class="site-header__btn site-header__btn--login btn btn--style--stroke" @click="logout" v-if="$root.$data.user">
										<span>Logout</span>
									</span>

								</mq-layout>
							</div>

						</div>
					</div>


				</div>
				<div class="grid__item">

					<div class="grid grid--middle grid--auto grid--g16--desk grid--g8--port">
						<div v-if="$root.userRegions && !$route.meta.isAdmin && $mq == 'desk'" class="grid__item">

							<div class="site-header__regions">
								<GlobalRegionIndicator class="site-header__region-indicator" :region="regionLabel($root.userSelectedRegionKey)" @click.native.stop="showRegionSelector = !showRegionSelector; closeTooltip(); trackEvent([
									'global-region-selector-clicked',
									showRegionSelector ? 'opened' : 'closed',
									$root.$data.user ? $root.$data.user.trackName : null,
									0,
									false
								])"></GlobalRegionIndicator>
								<InfoTooltip v-if="tooltipOpen" title="Change Regions" :above="false" :visible-on-hover="false" :visible-on-load="true" @close="closeTooltip">
									You can now see games and content for different regions! We’ve already selected yours but click the icon above on any page to change it.
								</InfoTooltip>
								<RegionSelector v-show="showRegionSelector" class="site-header__region-selector" v-model="$root.userSelectedRegionKey" :hasUserRegions="true" @input="showRegionSelector = false; trackEvent([
									'global-region-changed',
									$root.userSelectedRegionKey,
									$root.$data.user ? $root.$data.user.trackName : null,
									0,
									false
								])" @click.native.stop></RegionSelector>
							</div>

						</div>
						<div class="grid__item">

							<div class="site-header__profile-wrapper">
								<action-tooltip :offset="60">
									<template slot="icon">
										<span class="site-header__icon site-header__icon--profile grunticon grunticon--profile"></span>
									</template>
			 						<router-link :to="{ name: 'Login' }" v-if="!$root.$data.user">
										<span>Login</span>
									</router-link>
									<router-link :to="{ name: 'Dashboard' }" v-if="$root.userHasPermission({
										igt: ['SA']
									})">
										<span>Dashboard</span>
									</router-link>
									<span class="clickable" @click="logout" v-if="$root.$data.user">
										<span>Logout</span>
									</span>
								</action-tooltip>
							</div>

						</div>
						<mq-layout :mq="['mob', 'ptab', 'ltab']" class="grid__item">

							<a class="site-header__icon site-header__icon--burger fonticon fonticon--burger" @click="burgerOpen = true"></a>
							<InfoTooltip v-if="tooltipOpen" title="Change Regions" :above="false" :offset="92" :visible-on-hover="false" :visible-on-load="true" @close="closeTooltip">
								You can now see games and content for different regions! We’ve already selected yours but click the icon above on any page to change it.
							</InfoTooltip>

						</mq-layout>
					</div>


				</div>
			</div>

		</div>
	</header>
</template>

<script>
import { map } from 'lodash'
import { mapGetters } from 'vuex'

import Btn from '../atoms/Btn'
import GlobalRegionIndicator from '../atoms/GlobalRegionIndicator'
import RegionSelector from '../atoms/RegionSelector'
import ActionTooltip from '../molecules/ActionTooltip'
import InfoTooltip from '../molecules/InfoTooltip'

export default {
	name: 'SiteHeader',
	components: {
		Btn,
		GlobalRegionIndicator,
		RegionSelector,
		ActionTooltip,
		InfoTooltip,
	},
	data () {
		return {
			burgerOpen: false,
			tooltipOpen: false,
			showRegionSelector: false,
		}
	},
	computed: {
		...mapGetters({
			'flattenRegions': 'app/flattenRegions',
			'regionLabel': 'app/regionLabel',
		}),
		userRegionOptions: function()
		{
			const flatRegions = this.flattenRegions();
			return this.$root.userRegions ? map(this.$root.userRegions, region => {
				return {
					label: flatRegions[region.region].label,
					value: region.region
				}
			}) : [];
		}
	},
	created: function()
	{
		// Tooltip already closed?
		this.tooltipOpen = !this.$cookies.isKey("regionHeaderTooltipClosed") || !this.$cookies.get("regionHeaderTooltipClosed");
	},
	mounted: function()
	{
		var self = this;
		var logo = self.$refs.logo;

		if(logo)
		{
			if(logo.isComplete)
			{
				self.refreshHeaderSize();
			}
			else
			{
				logo.addEventListener('load', function()
				{
					self.refreshHeaderSize();
				});
			}
		}

		window.addEventListener("resize", self.refreshHeaderSize);

		this.$eventBus.$on('window-click', this.closeAllPopups);

	},
	beforeDestroy: function()
	{
		window.removeEventListener("resize", self.refreshHeaderSize);
		this.$eventBus.$off('window-click', this.closeAllPopups);
	},
	methods: {
		refreshHeaderSize: function()
		{
			var self = this;

			self.$root.$data.headerHeight = self.$el.offsetHeight;
		},
		closeAllPopups: function()
		{
			this.showRegionSelector = false;
		},
		logout: function(event)
		{
			var self = this;

			self.$api.setToken(null);
			self.$root.$data.user = null;
			self.$alert.success({ message: "Logout successful" });
			self.$eventBus.$emit('logout');
		},
		closeTooltip()
		{
			this.tooltipOpen = false;
			this.$cookies.set("regionHeaderTooltipClosed", true, Infinity);
		},
		showHide()
		{
			console.log(this);
		}
	}
}
</script>

<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".site-header";
	#{$c}
	{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		color: palette(header, contrast);
		font-size: 14px;
		z-index: 1000;
		background-color: transparentize(palette(header, base, true), 1);

		@include css-variables
		{
			transition: background-color calc(1s * #{var(base-trans-speed)});
		}

		@include media(phab)
		{
			padding: { top: rem(16); bottom: rem(16); }
		}

		@include media(not-phab)
		{
			padding: { top: rem(20); bottom: rem(20); }
		}

		@include media(port)
		{
			&:before
			{
				content: "";
				display: block;
				position: fixed;
				width: 0;
				height: 0;
				top: 0;
				left: 0;
				background-color: transparentize(palette(black, base, true), 1);
				z-index: -1;

				@include css-variables()
				{
					transition: background-color calc(1s * #{var(base-trans-speed)});
				}
			}

			&--burger-nav-open:before
			{
				width: 100vw;
				height: 100vh;
				background-color: transparentize(palette(black, base, true), 0.3);
				z-index: 999;
			}
		}

		.is-admin &,
//		.is-scrolled &,
		&--fill
		{
			background-color: palette(header);

			&#{$c}--light
			{
				@include extend(bgc-pal--lightest-grey)
			}
		}

		&__centraliser
		{
			@include extend(page-container);

			// Removed to accomodate region selector on smaller desktops
			// @include media(desk)
			// {
			// 	padding: { left: 48px; right: 48px; }
			// 	max-width: 1825px + 48px + 48px;
			// }
		}

		&__logo
		{
			@include extend(block-img);
			max-width: 100px;
		}

		&__burger-content
		{
			@include media(port)
			{
				position: fixed;
				right: 0;
				top: 0;
				bottom: 0;
				width: 330px;
				height: 100%;
				overflow: scroll;
				background-color: palette(font);
				color: palette(light-grey);
				z-index: 1000;
				padding: 27px 16px 32px;
				transform: translateX(101%);

				@include css-variables()
				{
					transition: transform calc(1s * #{var(base-trans-speed)});
				}

				#{$c}--burger-nav-open &
				{
					transform: translateX(0%);
				}
			}
		}

		&__nav
		{
			@include media(port)
			{
				font-size: rem(22);
				padding-left: rem(24);
			}

			&-icon
			{
				margin-right: rem(4);
				vertical-align: middle;
			}

			&-action
			{
				@include media(desk)
				{
					@include extend(ui-underline);

					&:after
					{
						bottom: -12px;
					}

					&:not(#{$c}__nav-action--login).router-link-active
					{
						@include extend(ui-underline--active);

						#{$c}--light &
						{
							@include extend(ui-underline--blue);
						}
					}
				}
			}
		}

		&__regions
		{
			position: relative;
		}

		&__region-selector
		{
			position: absolute;
			right: 0;
			top: calc(100% + 14px);
			box-shadow: 0 4px 8px rgba(0,0,0,0.25);
			z-index: 10;

			@include media(port)
			{
				right: -48px;
				max-width: calc(330px - 32px) !important;
				padding-left: 16px !important;
				padding-right: 16px !important;
			}

			&:before
			{
				content: '';
				display: block;
				position: absolute;
				width: 0;
				height: 0;
				bottom: calc(100% - 1px);
				right: rem(40);
				border-width: 0 6px 7px 6px;
				border-style: solid;
				border-color: transparent transparent palette(white) transparent;

				@include media(port)
				{
					right: 88px;
				}
			}
		}

		&__region-indicator
		{
			.global-region-indicator__region
			{
				@include breakpoint($desk-lap)
				{
					max-width: calc(100vw - 980px);
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		&__profile-wrapper
		{
			@include media(desk)
			{
				position: relative;
				padding-right: 18px;

				&:after
				{
					content: "";
					display: block;
					position: absolute;
					width: 0;
					height: 0;
					border-color: currentColor transparent transparent transparent;
					border-style: solid;
					border-width: 5px 5px 0px 5px;
					top: 50%;
					right: 0;
					transform: translateY(-50%);
				}
			}
		}

		&__icon
		{
			cursor: pointer;
			font-size: 40px;

			&--burger-close
			{
				color: palette(white);
			}
		}

		&__btn
		{
			&--login
			{
				width: 100%;
				color: palette(white);
			}
		}
	}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: rgba(0,0,0,0.7);
  width: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.5);
  z-index: 1;
  border-radius: 5px;
  padding: 5px 0px;
}

.dropdown-content a {
  color: #fff;
  padding: 5px 16px 0px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}
.dropdown-content a:last-child{
	padding: 5px 16px 5px;
}
.dropdown:hover .dropdown-content {display: block;}
.caret_icon{
	display : none;
}
.dropdown-content a::after{
	display : none;
}
@media(max-width: 767px){
	.has-submenu{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.caret_icon{
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: currentcolor transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    top: 50%;
	right: 0;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}
.dropdown-content {
  width: 90%;
}

}

@media(min-width: 768px) and (max-width: 1023px){
	.has-submenu{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.caret_icon{
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: currentcolor transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    top: 50%;
	right: 0;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}
.dropdown-content {
  width: 90%;
}

}
</style>



// WEBPACK FOOTER //
// src/components/organisms/SiteHeader.vue